import './App.css';

import Navbar from './components/NavBar';
// import FloatingSidebar from './components/FloatingSidebar';
import FooterNew from './components/FooterNew';

import Header from './components/Header';
import Master from './components/Master';
import StudyMethod from './components/StudyMethod';
import NewStudyMethod from './components/NewStudyMethod';
import Memberships from './components/Memberships';
import Financing from './components/Financing';
import Counseling from './components/Counseling';
import FeaturedResults from './components/FeaturedResults';
import FAQ from './components/FAQ';
import ContentMaster from './components/ContentMaster';
import HeaderForm from './components/HeaderForm';
import Gallery from './components/Gallery';
import Plans from './components/Plans';

function App() {
	return (
		<main className='App'>
			<Navbar />
			{/* <FloatingSidebar /> */}
			<Header />
			{/* <Master /> */}
			<ContentMaster />
			<NewStudyMethod />
			<Gallery />
			<HeaderForm />
			{/* <Plans /> */}
			{/* <Memberships /> */}
			{/* <Financing /> */}
			<Counseling />
			{/* <FeaturedResults /> */}
			<FAQ />
			<FooterNew />
		</main>
	);
}

export default App;
